import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-menu-cabinet',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class MenuCabinetComponent {

}
